import { PLAN_NAMES } from "../../../constants";

export const PLAN_DISPLAY_NAMES = {
  [PLAN_NAMES.PLUS]: "IndusInd Nippon Life Super Suraksha Plus",
  [PLAN_NAMES.ELITE]: "IndusInd Nippon Life Super Suraksha Elite",
};

export const PLAN_TO_PRODUCT_CODE = {
  "Super Suraksha Plus": "BI_RNL_Super_Suraksha_Plus_121N148V01_V15",
  "Super Suraksha Elite": "BI_RNL_Super_Suraksha_Elite_121N148V01_V15",
};

/**
 * Map persisted quote `productName` / `selectedPlan` to a plan the UI may show at this pincode.
 * Used when returning from summary so we don't reset to Elite while Redux premium is still for Plus.
 *
 * @param {string|null|undefined} savedPlanName
 * @param {string[]} visibleTermPlans - subset of PLAN_NAMES values currently offered
 * @returns {string|null} PLAN_NAMES value or null
 */
export function resolveVisiblePlanFromSavedQuote(savedPlanName, visibleTermPlans) {
  if (
    savedPlanName == null ||
    typeof savedPlanName !== "string" ||
    !visibleTermPlans?.length
  ) {
    return null;
  }
  const name = savedPlanName.trim();
  if (!name) return null;

  if (visibleTermPlans.includes(PLAN_NAMES.PLUS) && name === PLAN_NAMES.PLUS) {
    return PLAN_NAMES.PLUS;
  }
  if (visibleTermPlans.includes(PLAN_NAMES.ELITE) && name === PLAN_NAMES.ELITE) {
    return PLAN_NAMES.ELITE;
  }

  const lower = name.toLowerCase();
  if (
    visibleTermPlans.includes(PLAN_NAMES.PLUS) &&
    lower.includes("plus") &&
    !lower.includes("elite")
  ) {
    return PLAN_NAMES.PLUS;
  }
  if (visibleTermPlans.includes(PLAN_NAMES.ELITE) && lower.includes("elite")) {
    return PLAN_NAMES.ELITE;
  }
  return null;
}
